import { exposePostMsg } from './postmsg-service';

const STYLE_ID = 'external_style';

function setStyle(styleString) {
    document.getElementById(STYLE_ID)?.remove();

    const headNode = document.head || document.getElementsByTagName('head')[0];
    const styleNode = document.createElement('style');
    const sanitizeStyle = styleString.replace(/(<([^>]+)>)/ig, '');

    headNode.appendChild(styleNode);

    styleNode.setAttribute('id', STYLE_ID);
    styleNode.setAttribute('type', 'text/css');
    styleNode.appendChild(document.createTextNode(sanitizeStyle));

    return Promise.resolve();
}

exposePostMsg('setStyle', setStyle);
